module.exports = __webpack_public_path__ + "img/icon-share.f04bc116.png";